"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CollectionEvent = void 0;

var _AssertionError = _interopRequireDefault(require("./AssertionError.js"));

var _Object = _interopRequireDefault(require("./Object.js"));

var _CollectionEventType = _interopRequireDefault(require("./CollectionEventType.js"));

var _Event = _interopRequireDefault(require("./events/Event.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Collection
 */


/**
 * @enum {string}
 * @private
 */
var Property = {
  LENGTH: 'length'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/Collection~Collection} instances are instances of this
 * type.
 */

var CollectionEvent =
/** @class */
function (_super) {
  __extends(CollectionEvent, _super);
  /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {*} [opt_element] Element.
   * @param {number} [opt_index] The index of the added or removed element.
   */


  function CollectionEvent(type, opt_element, opt_index) {
    var _this = _super.call(this, type) || this;
    /**
     * The element that is added to or removed from the collection.
     * @type {*}
     * @api
     */


    _this.element = opt_element;
    /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */

    _this.index = opt_index;
    return _this;
  }

  return CollectionEvent;
}(_Event["default"]);

exports.CollectionEvent = CollectionEvent;

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */

/**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */
var Collection =
/** @class */
function (_super) {
  __extends(Collection, _super);
  /**
   * @param {Array<T>} [opt_array] Array.
   * @param {Options} [opt_options] Collection options.
   */


  function Collection(opt_array, opt_options) {
    var _this = _super.call(this) || this;
    /***
     * @type {CollectionOnSignature<import("./events").EventsKey>}
     */


    _this.on;
    /***
     * @type {CollectionOnSignature<import("./events").EventsKey>}
     */

    _this.once;
    /***
     * @type {CollectionOnSignature<void>}
     */

    _this.un;
    var options = opt_options || {};
    /**
     * @private
     * @type {boolean}
     */

    _this.unique_ = !!options.unique;
    /**
     * @private
     * @type {!Array<T>}
     */

    _this.array_ = opt_array ? opt_array : [];

    if (_this.unique_) {
      for (var i = 0, ii = _this.array_.length; i < ii; ++i) {
        _this.assertUnique_(_this.array_[i], i);
      }
    }

    _this.updateLength_();

    return _this;
  }
  /**
   * Remove all elements from the collection.
   * @api
   */


  Collection.prototype.clear = function () {
    while (this.getLength() > 0) {
      this.pop();
    }
  };
  /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */


  Collection.prototype.extend = function (arr) {
    for (var i = 0, ii = arr.length; i < ii; ++i) {
      this.push(arr[i]);
    }

    return this;
  };
  /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */


  Collection.prototype.forEach = function (f) {
    var array = this.array_;

    for (var i = 0, ii = array.length; i < ii; ++i) {
      f(array[i], i, array);
    }
  };
  /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */


  Collection.prototype.getArray = function () {
    return this.array_;
  };
  /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */


  Collection.prototype.item = function (index) {
    return this.array_[index];
  };
  /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */


  Collection.prototype.getLength = function () {
    return this.get(Property.LENGTH);
  };
  /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */


  Collection.prototype.insertAt = function (index, elem) {
    if (this.unique_) {
      this.assertUnique_(elem);
    }

    this.array_.splice(index, 0, elem);
    this.updateLength_();
    this.dispatchEvent(new CollectionEvent(_CollectionEventType["default"].ADD, elem, index));
  };
  /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */


  Collection.prototype.pop = function () {
    return this.removeAt(this.getLength() - 1);
  };
  /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */


  Collection.prototype.push = function (elem) {
    if (this.unique_) {
      this.assertUnique_(elem);
    }

    var n = this.getLength();
    this.insertAt(n, elem);
    return this.getLength();
  };
  /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */


  Collection.prototype.remove = function (elem) {
    var arr = this.array_;

    for (var i = 0, ii = arr.length; i < ii; ++i) {
      if (arr[i] === elem) {
        return this.removeAt(i);
      }
    }

    return undefined;
  };
  /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */


  Collection.prototype.removeAt = function (index) {
    var prev = this.array_[index];
    this.array_.splice(index, 1);
    this.updateLength_();
    this.dispatchEvent(new CollectionEvent(_CollectionEventType["default"].REMOVE, prev, index));
    return prev;
  };
  /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */


  Collection.prototype.setAt = function (index, elem) {
    var n = this.getLength();

    if (index < n) {
      if (this.unique_) {
        this.assertUnique_(elem, index);
      }

      var prev = this.array_[index];
      this.array_[index] = elem;
      this.dispatchEvent(new CollectionEvent(_CollectionEventType["default"].REMOVE, prev, index));
      this.dispatchEvent(new CollectionEvent(_CollectionEventType["default"].ADD, elem, index));
    } else {
      for (var j = n; j < index; ++j) {
        this.insertAt(j, undefined);
      }

      this.insertAt(index, elem);
    }
  };
  /**
   * @private
   */


  Collection.prototype.updateLength_ = function () {
    this.set(Property.LENGTH, this.array_.length);
  };
  /**
   * @private
   * @param {T} elem Element.
   * @param {number} [opt_except] Optional index to ignore.
   */


  Collection.prototype.assertUnique_ = function (elem, opt_except) {
    for (var i = 0, ii = this.array_.length; i < ii; ++i) {
      if (this.array_[i] === elem && i !== opt_except) {
        throw new _AssertionError["default"](58);
      }
    }
  };

  return Collection;
}(_Object["default"]);

var _default = Collection;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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